import type { WidgetDefinition, WidgetProps } from '@/types/widget';

// The iframe escape hatch (brainstorm Q6). Lets users wrap ANY URL as a widget.
// Same-origin for our own surfaces (/board, /settings) so auth cookies flow;
// sandboxed for external URLs.

function IframeWidget({ config }: WidgetProps) {
  const url = (config.url as string) ?? '';
  const allowScripts = Boolean(config.allowScripts);
  const sandbox = allowScripts
    ? 'allow-scripts allow-same-origin allow-forms'
    : 'allow-same-origin';

  if (!url) {
    return (
      <div className="sp-widget">
        <div className="sp-widget-header">
          <span>iframe</span>
        </div>
        <div className="sp-empty" style={{ margin: 0, flex: 1 }}>
          Configure a URL for this widget.
        </div>
      </div>
    );
  }

  return (
    <div className="sp-widget" style={{ padding: 0 }}>
      <iframe
        src={url}
        title="Embedded surface"
        sandbox={sandbox}
        style={{ width: '100%', height: '100%', border: 0, borderRadius: 6 }}
      />
    </div>
  );
}

export const iframeWidget: WidgetDefinition = {
  id: 'iframe',
  name: 'iframe',
  description: 'Embed any URL. Escape hatch for surfaces not yet widgetized.',
  icon: 'square-code',
  category: 'universal',
  scope: 'both',
  defaultSize: { w: 6, h: 4 },
  minSize: { w: 2, h: 2 },
  configSchema: {
    type: 'object',
    required: ['url'],
    properties: {
      url: { type: 'string', title: 'URL', format: 'uri' },
      allowScripts: { type: 'boolean', title: 'Allow scripts', default: false },
    },
  },
  component: IframeWidget,
};
